const TOKEN_KEY = 'access_token'
const LAST_USED_USERNAME = 'last_used_username'

const StorageService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken);
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY);
    },

    get(key) {
        return localStorage.getItem(key);
    },

    save(key, value) {
        localStorage.setItem(key, value);
    },

    remove(key) {
        localStorage.removeItem(key);
    }
}

export { StorageService, LAST_USED_USERNAME }